import { useMutation } from '@common-fe/common-fe';

import { api } from '@/api';
import { API_URL } from '@/dtos';

interface Response {
  upload_url?: string;
  file_name?: string;
  object_key?: string;
}

interface Payload {
  documentId: string;
  fileName?: string;
  employeeId?: string;
}

const useCreateFileUploadUrlQuery = () => {
  const { mutateAsync, isLoading } = useMutation((payload: Payload) =>
    api.post<Response>(API_URL.DOCUMENTS_FILES_LINK_BY_DOCUMENT_ID(payload?.documentId), {
      name: payload?.fileName,
      employee_id: payload.employeeId,
    })
  );

  return {
    createFileUploadUrl: mutateAsync,
    isLoading,
  };
};

export default useCreateFileUploadUrlQuery;
